import { windowWidth } from "@styles/global";
import styled from "styled-components";
import { shade } from "polished";

const LoginFormContainer = styled.div`
  background-color: white;
  padding: 10px 25px;
  width: 95%;
  height: 90%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 655px;

  @media (max-width: ${windowWidth.mobile.large}) {
    padding: 20px 20px !important;
  }

  > form {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    align-items: center;

    > * {
      width: 100%;
    }

    > button {
      margin-top: 20px;
      width: 50%;
      background-color: ${(props) => props.theme.colors.primary};

      &:hover {
        background-color: ${(props) => props.theme.colors.secondary};
      }
    }
  }
`;

const LoginFormLogo = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
    
  svg {
    width: 100%;
    max-height: 28vh;
  }
    
  .logoDiv {
    width: 100%;
  }

  @media (max-height: 700px) {
    padding-bottom: 20px;
  }

  // Used to dont need to scroll de login form div
  @media (max-height: 700px) and (max-width: ${windowWidth.mobile.large}) {
      svg {
        max-height: 25vh;
      }
  }
`;

const LoginCallToAction = styled.div`
  text-align: center;

  a,
  a:active,
  a:hover {
    text-decoration: underline;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.primary};
    transition: 0.5s;
    margin: 10px 0;
    display: block;
  }

  a:hover {
    color: ${({ theme }) => shade(0.5, theme.colors.primary)};
  }
`;

export { LoginFormContainer, LoginFormLogo, LoginCallToAction };
